/**
 * Count valid seals on a route session (non-deleted, with photo).
 * @param {Array} seals - The seals array from a route session
 * @returns {number} Count of valid seals
 */
export const countValidSeals = (seals) => {
    if (!seals || !Array.isArray(seals)) return 0;
    // TODO: Re-enable slip_s3_location check with product team approval
    // return seals.filter((s) => s.deleted_at == null && s.slip_s3_location != null && s.slip_s3_location !== '').length;
    return seals.filter((s) => s.deleted_at == null).length;
};

/**
 * Filter route sessions that meet the seal requirement.
 * @param {Array} routeSessions - Array of route session objects
 * @param {number} requiredSeals - Required number of valid seals (0 means no filtering)
 * @returns {Array} Route sessions that meet the requirement
 */
export const filterRouteSessionsBySealRequirement = (routeSessions, requiredSeals) => {
    if (!requiredSeals || requiredSeals === 0) return routeSessions;
    if (!routeSessions || !Array.isArray(routeSessions)) return [];
    return routeSessions.filter((rs) => countValidSeals(rs.seals) >= requiredSeals);
};

/**
 * Check if a route session meets the seal requirement.
 * @param {Array} seals - The seals array from a route session
 * @param {number} requiredSeals - The required number of valid seals (0 means no requirement)
 * @returns {{ met: boolean, message: string|null }}
 */
export const checkSealRequirement = (seals, requiredSeals) => {
    if (!requiredSeals || requiredSeals === 0) return { met: true, message: null };
    const validCount = countValidSeals(seals);
    if (validCount >= requiredSeals) return { met: true, message: null };
    return {
        met: false,
        message: `${requiredSeals} seals with photos required on route session (${validCount} of ${requiredSeals})`,
    };
};
